import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/* Router Modules */

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [

  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect:process.env.VUE_APP_COMPANY_CODE=='chongheng'? '/chongheng/employee':'/store',
    children: [
      // /amiba
     
      {
        path: '/store',
        component: () => import('@/views/admin/storeSet/index.vue'),
        name: 'store',
        meta: { title: '店铺管理' }
      },
      {
        path: '/team',
        component: () => import('@/views/admin/teamSet/index.vue'),
        name: 'team',
        meta: { title: '团队管理' }
      },
      {
        path: '/duty',
        component: () => import('@/views/admin/dutySet/index.vue'),
        name: 'duty',
        meta: { title: '任务管理' }
      },
      {
        path: '/food',
        component: () => import('@/views/admin/foodSet/index.vue'),
        name: 'food',
        meta: { title: '能量管理' }
      },
      {
        path: '/home',
        component: () => import('@/views/admin/staffSet/index.vue'),
        name: 'home',
        meta: { title: '员工管理', isTab: true }
      },
      {
        path: '/award',
        component: () => import('@/views/admin/awardSet/index.vue'),
        name: 'award',
        meta: { title: '奖金管理', isTab: true }
      },
      {
        path: '/systemBase',
        component: () => import('@/views/admin/systemSet/baseSet/index.vue'),
        name: 'base',
        meta: { title: '基础设置', isTab: true }
      },
      {
        path: '/power',
        component: () => import('@/views/admin/systemSet/powerSet/index.vue'),
        name: 'power',
        meta: { title: '岗位设置', isTab: true }
      },
      {
        path: '/lodge',
        component: () => import('@/views/admin/lodgeSet/index.vue'),
        name: 'lodge',
        meta: { title: '匿名投诉', isTab: true }
      },
      // chongheng
      {
        path: '/chongheng/employee',
        component: () => import('@/views/chongheng/staffSet/index.vue'),
        name: 'employee',
        meta: { title: '员工管理', isTab: true }
      },
      {
        path: '/chongheng/skill',
        component: () => import('@/views/chongheng/dutySet/index.vue'),
        name: 'skill',
        meta: { title: '任务管理' }
      },
      {
        path: '/chongheng/module',
        component: () => import('@/views/chongheng/modulesSet/index.vue'),
        name: 'module',
        meta: { title: '发布任务' }
      },
      {
        path: '/chongheng/banner',
        component: () => import('@/views/chongheng/bannerSet/index.vue'),
        name: 'banner',
        meta: { title: 'banner管理' }
      },
      {
        path: '/chongheng/lodge',
        component: () => import('@/views/chongheng/lodgeSet/index.vue'),
        name: 'lodge',
        meta: { title: '匿名投诉', isTab: true }
      },
      {
        path: '/chongheng/statistical',
        component: () => import('@/views/chongheng/statistical/index.vue'),
        name: 'statistical',
        meta: { title: '月统计', isTab: true }
      },
      {
        path: '/chongheng/sysnotice',
        component: () => import('@/views/chongheng/sysnotice/index.vue'),
        name: 'sysnotice',
        meta: { title: '公告设置', isTab: true }
      }
    ]
  }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
